import React, { forwardRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { MenuDivider as LibMenuDivider } from '@szhsin/react-menu';

// eslint-disable-next-line prefer-arrow-callback
const MenuDivider = forwardRef(function MenuDivider(
  { fullWidth, dense, className, ...restProps },
  ref
) {
  return (
    <LibMenuDivider
      ref={ref}
      className={cx(className, {
        'szh-menu__divider--full-width': fullWidth,
        'szh-menu__divider--dense': dense,
      })}
      {...restProps}
    />
  );
});

MenuDivider.propTypes = {
  fullWidth: T.bool,
  dense: T.bool,
  className: T.string,
};

export default MenuDivider;
